(function () {
  'use strict';

  function Toast(message, status, timeout, opts) {
    // Set default values
    message = message || '';
    status = status || 'info';
    timeout = timeout || 5000;

    opts = opts || {};

    let defaults = {
      onClose: function () {},
      closeLabel: 'Close notification',
    };

    opts = util.deepExtend(defaults, opts);

    // Used to determine whether to remove setTimeout or not
    let toastTimeout;

    // Create alert element
    const toast = document.createElement('div');
    toast.classList.add('toast__item');

    // Attach correct colour to alert
    toast.classList.add('is-' + status);

    // Create close button
    const closeButton = document.createElement('a');
    closeButton.classList.add('toast__close');
    closeButton.setAttribute('aria-label', opts.closeLabel);
    closeButton.href = '#';
    closeButton.innerHTML =
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="currentColor" d="M446.627 110.627l-45.254-45.254-145.373 145.372-145.373-145.372-45.254 45.253 145.373 145.374-145.373 145.373 45.254 45.254 145.373-145.373 145.373 145.373 45.254-45.255-145.372-145.372z"></path></svg>';

    // Add message and close button
    const toastMessage = document.createElement('div');
    toastMessage.classList.add('toast__message');
    toastMessage.innerHTML = message;

    toast.appendChild(closeButton);
    toast.appendChild(toastMessage);

    // Event listeners
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });

    toast.addEventListener('mouseover', () => {
      if (toast.classList.contains('is-fade-out') === false)
        clearTimeout(toastTimeout);
    });

    toast.addEventListener('mouseout', () => {
      toastTimeout = window.setTimeout(() => {
        close();
      }, 3000);
    });

    // Prepend new alert to container
    let toastContainer = document.querySelector('.toast__container');
    let toastWrapper = document.querySelector('.toast__wrapper');

    // Create container if it doesn't exist
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.classList.add('toast__container');

      toastWrapper = document.createElement('div');
      toastWrapper.classList.add('toast__wrapper');

      toastContainer.appendChild(toastWrapper);
      document.querySelector('body').appendChild(toastContainer);
    }

    toastWrapper.insertBefore(toast, toastWrapper.children[0]);

    // If they haven't clicked close within the timeout period, fade out and remove element
    toastTimeout = window.setTimeout(() => {
      close();
    }, timeout);

    function close() {
      if (toast.parentNode) {
        toast.classList.add('is-fade-out');
        toastTimeout = window.setTimeout(() => {
          toast.parentNode.removeChild(toast);
          opts.onClose();
        }, 500);
      }
    }

    return {
      close: close,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Toast;
  } else {
    window.Toast = Toast;
  }
})();
